__turbopack_context__.v({
  "character-count": "Textarea-module-scss-module__zpIm4G__character-count",
  "character-count-wrapper": "Textarea-module-scss-module__zpIm4G__character-count-wrapper",
  "error-text": "Textarea-module-scss-module__zpIm4G__error-text",
  "over-limit": "Textarea-module-scss-module__zpIm4G__over-limit",
  "textarea-wrapper": "Textarea-module-scss-module__zpIm4G__textarea-wrapper",
});
